/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoMacelloUpdateDTO
 */
export interface MovimentoMacelloUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloUpdateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoMacelloUpdateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloUpdateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloUpdateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoMacelloUpdateDTO
     */
    dataMacellazione?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloUpdateDTO
     */
    capi?: number;
}

/**
 * Check if a given object implements the MovimentoMacelloUpdateDTO interface.
 */
export function instanceOfMovimentoMacelloUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoMacelloUpdateDTOFromJSON(json: any): MovimentoMacelloUpdateDTO {
    return MovimentoMacelloUpdateDTOFromJSONTyped(json, false);
}

export function MovimentoMacelloUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoMacelloUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'dataMacellazione': !exists(json, 'dataMacellazione') ? undefined : (json['dataMacellazione'] === null ? null : new Date(json['dataMacellazione'])),
        'capi': !exists(json, 'capi') ? undefined : json['capi'],
    };
}

export function MovimentoMacelloUpdateDTOToJSON(value?: MovimentoMacelloUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'dataMacellazione': value.dataMacellazione === undefined ? undefined : (value.dataMacellazione === null ? null : value.dataMacellazione.toISOString()),
        'capi': value.capi,
    };
}

